import { create } from "zustand";

import type { JobHandler } from "@/types/jobs";

type JobHandlersState = {
  handlersByType: Record<string, JobHandler>;
  registerHandler: (handler: JobHandler) => void;
};

export const useJobHandlersStore = create<JobHandlersState>((set) => ({
  handlersByType: {},
  registerHandler: (handler) =>
    set((state) => {
      if (state.handlersByType[handler.type]) return state;
      return {
        handlersByType: { ...state.handlersByType, [handler.type]: handler },
      };
    }),
}));
